import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import './Styles/index.css';
import AppRouter from './Routers/AppRouter';
import configureStore from './Store/configureStore';
import 'normalize.css/normalize.css';
import '@nike/ruxac/fonts';
import '@nike/ruxac/styles';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import registerServiceWorker from './registerServiceWorker';

const store = configureStore();
const AppJsx = (
    <Provider store={store}>
        <AppRouter />
    </Provider>
);
ReactDOM.render(AppJsx, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js